import React, { useMemo } from 'react';
import { Stack, Typography } from '@mui/material';
import Grid from '@mui/material/Grid2';
import { LenderFieldMap, PortalConfiguration } from '@trnsact/trnsact-shared-types';
import { LenderProfile } from 'types';
import { useCategoryStats } from 'modules/vendorOpportunity/dynamicLenderSubmissionMappings/hooks/useCategoryStats';
import { FormSection } from './FormSection';
import { MappingRow } from './mappingRow';

interface Props {
  category: string;
  sections: Record<string, LenderFieldMap[]>;
  lender: LenderProfile;
  portalConfiguration: PortalConfiguration;
  onValueChange: (lenderProperty: string, newValue: any) => void;
}

export const CategorySection = ({ category, sections, lender, portalConfiguration, onValueChange }: Props) => {
  const allFields = useMemo(
    () =>
      Object.values(sections)
        .flat()
        .filter(field => !field.details?.hidden),
    [sections]
  );

  const { total, requiredTotal, filled, requiredFilled } = useCategoryStats(allFields);

  return (
    <FormSection
      title={category}
      isExpanded
      isExpandable
      requiredStatus={{ current: requiredFilled, total: requiredTotal }}
      totalStatus={{ current: filled, total }}
    >
      {Object.entries(sections).map(([section, fields]) => (
        <Stack key={section} gap={2}>
          <Grid container spacing={2}>
            <Grid size={5} display="flex" justifyContent="center">
              <Typography variant="subtitle2" component="span">
                Trnsact
              </Typography>
            </Grid>
            <Grid size={5} offset={2} display="flex" justifyContent="center">
              <Typography variant="subtitle2" component="span">
                {lender.lenderName}
              </Typography>
            </Grid>
          </Grid>
          {fields
            .filter(field => !field.details?.hidden)
            .map(field => (
              <MappingRow
                key={field.lenderProperty}
                field={field}
                portalConfiguration={portalConfiguration}
                onValueChange={onValueChange}
              />
            ))}
        </Stack>
      ))}
    </FormSection>
  );
};
